import Geo from "../../entities/Geo";
import Phone from "../../entities/Phone";
import DeliveryOrderComment from "../../entities/productOrder/DeliveryOrderComment";
import ProductOrderStatus from "../../entities/productOrder/ProductOrderStatus";
import ProductOrderAttachmentResponse from "../productOrder/ProductOrderAttachmentResponse";
import ArticleDeliveryOrderArticleResponse from "./ArticleDeliveryOrderArticleResponse";
import DeliveryStepResponse from "./DeliveryStepResponse";
import WarehouseStepResponse from "./WarehouseStepResponse";

class ArticleDeliveryOrderResponse {
    public id: string;
    public orderNumber: string;
    public agencyId: string;
    public clientId: string;
    public agencyName: string;
    public clientName: string;
    public clientPhone: Phone | null;
    public contactId: string;
    public contactName: string;
    public contactPhone: Phone | null;
    public userId: string;
    public userName: string;
    public deliveryPersonId: string | null;
    public deliveryPersonName: string | null;
    public deliveryFlow: DeliveryStepResponse[];
    public totalToPay: number;
    public createdAt: number;
    public status: ProductOrderStatus;
    public address: string;
    public geo: Geo;
    public articles: ArticleDeliveryOrderArticleResponse[];
    public observations: string;
    public comments: DeliveryOrderComment[];
    public attachments: ProductOrderAttachmentResponse[];
    public warehouseStep: WarehouseStepResponse | null;

    constructor(
        id: string,
        orderNumber: string,
        agencyId: string,
        agencyName: string,
        clientId: string,
        clientName: string,
        clientPhone: Phone | null,
        contactId: string,
        contactName: string,
        contactPhone: Phone | null,
        userId: string,
        userName: string,
        deliveryPersonId: string,
        deliveryPersonName: string,
        deliveryFlow: DeliveryStepResponse[],
        totalToPay: number,
        status: ProductOrderStatus,
        createdAt: number,
        address: string,
        geo: Geo,
        articles: ArticleDeliveryOrderArticleResponse[],
        observations: string,
        comments: DeliveryOrderComment[],
        attachments: ProductOrderAttachmentResponse[],
        warehouseStep: WarehouseStepResponse | null = null,
    ) {
        this.id = id;
        this.orderNumber = orderNumber;
        this.agencyId = agencyId;
        this.agencyName = agencyName;
        this.clientId = clientId;
        this.clientName = clientName;
        this.clientPhone = clientPhone;
        this.contactId = contactId;
        this.contactName = contactName;
        this.contactPhone = contactPhone;
        this.userId = userId;
        this.userName = userName;
        this.deliveryPersonId = deliveryPersonId;
        this.contactName = contactName;
        this.deliveryPersonId = deliveryPersonId;
        this.deliveryPersonName = deliveryPersonName;
        this.deliveryFlow = deliveryFlow;
        this.totalToPay = totalToPay;
        this.status = status;
        this.createdAt = createdAt;
        this.address = address;
        this.geo = geo;
        this.articles = articles;
        this.observations = observations;
        this.comments = comments;
        this.attachments = attachments;
        this.warehouseStep = warehouseStep;
    }

}

export default ArticleDeliveryOrderResponse;